import React from 'react';
import styled from 'styled-components';

import FooterBox from 'components/FooterBox/footerBox';
import CopyrightParagraph from 'components/CopyrightParagraph/copyrightParagraph';

const StyledWrapper = styled.section`
  width: 100%;
  min-height: 30vh;
  position: relative;
  overflow: hidden;
  background: ${({ theme }) => theme.color.third};
`;

const FooterContainer = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 1fr;
  margin: 10px auto;
  background: ${({ theme }) => theme.color.third};
  ${({ theme }) => theme.mq.desktop} {
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 30px;
    align-items: start;
    margin: 20px 30px 20px 60px;
    justify-content: space-around;
  }
  ${({ theme }) => theme.mq.big} {
    margin: 40px 30px 20px 100px;
    justify-content: space-around;
  }
`;

const Footer = () => (
  <StyledWrapper id="footer">
    <FooterContainer>
      <FooterBox title="Adres biura">
        ul. Chopina 38/ lok 8,
        <br />
        83-000 Pruszcz Gdański
        <br /> tel. 999 999 999
        <br /> email: dzialkizamiastem@gmail.com
        <br />
      </FooterBox>
      <FooterBox title="Dane Firmy">
        MR LOCUM Sp. z o.o.
        <br /> KRS 0000815931
        <br /> NIP 6040215916
        <br /> REGON 384944261
        <br />
      </FooterBox>
      <FooterBox title="Ważne linki">
        Polityka Prywatności
        <br /> RODO
        <br /> Social Media
        <br />
      </FooterBox>
    </FooterContainer>
    <CopyrightParagraph />
  </StyledWrapper>
);

export default Footer;
